// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1QSiG","title":"Images45_title__16SuI","images":"Images45_images__2VkW8"};